import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

const Header = () => (
  <Navbar bg="light">
        <Container>
          <Navbar.Brand>SD敢达数据库</Navbar.Brand>
        </Container>
    </Navbar>
);

export default Header;